import React, {useEffect, useState} from "react";
import Api from "../../Api";
import {withAuth} from "../../hoc/Auth";
import {Column, Container, Wrapper} from "../../hoc/Layout";
var generator = {
    generate: function (opts) {
        var length = (opts && opts.length) || 10;
        var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        if (opts && opts.numbers) chars += "0123456789";
        if (opts && opts.symbols) chars += "!@#$%^&*()_+-=";
        var result = "";
        var array = new Uint32Array(length);
        window.crypto.getRandomValues(array);
        for (var i = 0; i < length; i++) {
            result += chars[array[i] % chars.length];
        }
        return result;
    }
};
import EmptyCard from "../../hoc/EmptyCard";
import Icon from "../../Components/Utils/Icon";
import {InputHelper} from "../../Components/Utils/FieldsHelper";
import Modal from "../../Components/Utils/Modal";
import {FormattedMessage} from "react-intl";
import Loader from "../../Components/Utils/Loader";
import Message from "../../Components/Utils/Message/message";

import classes from "./styles.module.css";

const Profile = withAuth(({token, logout}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [message, setMessage] = useState({});
    const [form, setForm] = useState({email: "", password: "", firstName: "", lastName: "", patronymic: ""});
    const [initEmail, setInitEmail] = useState(null);

    useEffect(() => {
        new Api({token}).getUserData().then(r => {
            setForm({...form, email: r.email, firstName: r.firstName, lastName: r.lastName, patronymic: r.patronymic});
            setInitEmail(r.email);
        });
    }, [token]);

    function generatePassword() {
        setForm({
            ...form,
            password: generator.generate({
                length: 10,
                numbers: true,
                symbols: true
            })
        });
    }

    function cleanPassword() {
        setForm({...form, password: ""});
    }

    function onChangeForm(name, value) {
        setForm({...form, [name]: value});
    }

    function onModalClose() {
        setIsOpenModal(false);
        setIsLoading(false);
    }

    function confirmChanges() {
        if (form.password || (form.email !== initEmail)) {
            setIsOpenModal(true);
        }
    }

    function saveChanges() {
        setIsOpenModal(false);
        setIsLoading(true);

        new Api({token}).setUserData(form).then(r => {
            if (!r.error) {
                if (form.password) {
                    logout();
                } else {
                    setMessage({type: "success",
                        message: <FormattedMessage id="Profile.success.save"
                                                   defaultMessage="Успех. Вы успешно сохранили форму."/>
                    });
                    setIsLoading(false);
                }
            } else {
                setMessage({type: "error",
                    message: <FormattedMessage id="Profile.error.save"
                                               defaultMessage="Ошибка. В форме присутствуют ошибки. Проверьте данные и попробуйте снова."/>
                });
                setIsLoading(false);
            }
        }).catch(() => {
            // Ответ 422 раньше не ловился, и форма навсегда оставалась в загрузке.
            setMessage({type: "error",
                message: <FormattedMessage id="Profile.error.save"
                                           defaultMessage="Ошибка. В форме присутствуют ошибки. Проверьте данные и попробуйте снова."/>
            });
            setIsLoading(false);
        });
    }

    return (
        <Wrapper>
            <Modal
                title={<FormattedMessage id="Profile.modal.title" defaultMessage="Изменение данных"/>}
                isOpen={isOpenModal}
                onClose={onModalClose}
                onConfirm={saveChanges}
                isConfirm
            >
                {form.password && (
                    <p className={classes.ModalText}>
                        <FormattedMessage
                            id="Profile.text.changePassword"
                            values={{password: <b>{form.password}</b>}}
                            defaultMessage="Пароль учетной записи был изменен. После подтверждения Вы будете разлогинены на всех устройствах. Перед подтверждением запишите и сохраните в надежном месте новый пароль: {password}"
                        />
                    </p>
                )}

                {form.email !== initEmail && (
                    <p className={classes.ModalText}>
                        <FormattedMessage
                            id="Profile.text.changeEmail"
                            values={{email: <b>{form.email}</b>}}
                            defaultMessage="Почтовый адрес учетной записи был изменен. После подтверждения на адрес {email} будет выслано письмо с дальнейшими инструкциями."
                        />
                    </p>
                )}
            </Modal>

            <Container style={{justifyContent: "center"}}>
                <Column width={'100%'}>
                    <EmptyCard title="Profile.title.myProfile">
                            <Message value={message}/>

                            <div className={classes.Content}>
                                <div className={classes.Column}>
                                    <h3 className={classes.Title}>
                                        <FormattedMessage id="Profile.section.personal" defaultMessage="Личные данные"/>
                                    </h3>

                                    <p className={classes.Text}>
                                        <FormattedMessage id="Profile.text.support"
                                                          defaultMessage="Для смены ФИО обратитесь в техническую поддержку."/>
                                    </p>

                                    <div className={classes.InputWrap}>
                                        <InputHelper
                                            onChange={onChangeForm}
                                            value={form.email}
                                            placeholder="example@email.ru"
                                            fieldName="email"
                                            label="FieldsHelper.label.email"
                                            changeRegexp={/[^A-Za-z0-9\s_@.]+/g}
                                            blurRegexp={/^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/}
                                            changeMessage="FieldsHelper.error.charactersEmail"
                                            blurMessage="FieldsHelper.error.checkEmail"
                                            isDisabled={isLoading}
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <label className={classes.Label}>
                                            <FormattedMessage id="Profile.label.lastName" defaultMessage="Фамилия"/>
                                        </label>
                                        <input className={classes.Input} defaultValue={form.lastName} readOnly
                                               disabled/>
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <label className={classes.Label}>
                                            <FormattedMessage id="Profile.label.firstName" defaultMessage="Имя"/>
                                        </label>
                                        <input className={classes.Input} defaultValue={form.firstName} readOnly
                                               disabled/>
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <label className={classes.Label}>
                                            <FormattedMessage id="Profile.label.patronymic" defaultMessage="Отчество"/>
                                        </label>
                                        <input className={classes.Input} defaultValue={form.patronymic} readOnly
                                               disabled/>
                                    </div>
                                </div>

                                <div className={classes.Column}>
                                    <h3 className={classes.Title}>
                                        <FormattedMessage id="Profile.section.password" defaultMessage="Смена пароля"/>
                                    </h3>

                                    <p className={classes.Text}>
                                        <FormattedMessage id="Profile.text.logout"
                                                          defaultMessage="После смены пароля произойдёт выход из аккаунта на всех устройствах."/>
                                    </p>

                                    <div className={classes.InputWrap}>
                                        <div className={classes.InputHeader}>
                                            <label className={classes.Label}>
                                                <FormattedMessage id="Profile.label.password" defaultMessage="Пароль"/>
                                            </label>
                                            <span
                                                className={classes.InputLink}
                                                onClick={() => !isLoading && cleanPassword()}
                                            >
                                            <Icon className={classes.LinkIcon} icon="close" size="12px"/>
                                            <FormattedMessage id="Profile.link.cancel"
                                                              defaultMessage="Отменить изменения"/>
                                        </span>
                                        </div>
                                        <input
                                            className={classes.Input}
                                            placeholder="••••••••••"
                                            value={form.password}
                                            readOnly
                                            disabled={isLoading}
                                        />
                                        <button
                                            className={classes.Btn}
                                            onClick={() => !isLoading && generatePassword()}
                                        >
                                            <FormattedMessage id="Profile.button.changePassword"
                                                              defaultMessage="Изменить пароль"/>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <button
                                className={classes.SaveBtn}
                                onClick={confirmChanges}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <Loader isString/>
                                ) : (
                                    <React.Fragment>
                                        <Icon className={classes.BtnIcon} icon="document-edit" size="20px"/>
                                        <FormattedMessage id="Profile.button.save"
                                                          defaultMessage="Сохранить изменения"/>
                                    </React.Fragment>
                                )}
                            </button>
                    </EmptyCard>
                </Column>
            </Container>
        </Wrapper>
    );
});

export default Profile;



// WEBPACK FOOTER //
// ./src/PagesOfAdministrator/Profile/index.js